export default __webpack_public_path__ + "static/ssems.gravityzone.bitdefender.com-8d66ed5e26f72de7000d4f57e51473e8.webp";